import { Fragment } from 'react';

import useOrgUnitAdminContactsDetail from './UseOrgUnitAdminContactsDetail';

import Views from '../../OrgUnitAdminUserViews';
import ViewTemplate from '../../../../../components/viewTemplateOmeTeamEntry/ViewTemplate';

import SearchEntryContactPopup from '@usas/ui-web/components/searches/searchMember/SearchEntryContactPopup';
import Input from '@usas/ui-web/components/inputs/Input';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';

import Constants from '@usas/ui-web/utils/Constants';

const OrgUnitAdminContactsDetail = () => {
  const { omeMeetOrgUnitContactState, omeMeetOrgUnitEntryRosterPermissionsState, omeMeetOrgUnitEntryState, formState, errorState, setFormData, handleSubmit, onFormValueChanged,
    onNextButtonClicked, onBackButtonClicked } = useOrgUnitAdminContactsDetail();

  return (
    <Fragment>
      <ViewTemplate
        viewName={Views.OME_MEET_INFO_CONTACTS}
        onNextButtonClicked={onNextButtonClicked}
        onBackButtonClicked={onBackButtonClicked}
        errorMessage={errorState.error}>
        <form onSubmit={handleSubmit} noValidate>
          <div className='row'>
            <div className="col-xs-12 col-sm-6 col-md-4">
              <SearchEntryContactPopup
                label={'Member Id*'}
                memberIdName={'memberId'}
                orgUnitId={omeMeetOrgUnitEntryState.objData?.orgUnitId}
                organzationName={omeMeetOrgUnitEntryState.objData?.orgUnit?.organization?.organizationName}
                formState={formState}
                errorState={errorState}
                setFormData={setFormData}
                onFormValueChanged={onFormValueChanged} />
            </div>
            <div className="col-xs-12 col-sm-6 col-md-4">
              <Input
                label="Email*"
                name="emailAddress"
                value={formState.emailAddress}
                error={errorState.emailAddress}
                message={errorState.emailAddress}
                onChange={(value) => { onFormValueChanged('emailAddress', value); }}
              />
            </div>
          </div>
        </form>
        <PopUpModal
          widthPct={50}
          maxWidth={250}
          title={Constants.SAVING_MSG}
          displayPopUp={omeMeetOrgUnitContactState.isSaving || omeMeetOrgUnitEntryRosterPermissionsState.isSaving} />
        <PopUpModal
          widthPct={50}
          maxWidth={250}
          title={Constants.LOADING_MSG}
          displayPopUp={omeMeetOrgUnitEntryState.isObjLoading} />
      </ViewTemplate>
    </Fragment>
  );
};

export default OrgUnitAdminContactsDetail;